import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Typography
} from "@mui/material";
import { useDispatch } from "react-redux";
import {ACTION_CLOSE_PASSWORD_CHANGE_SUCCESS_MODAL} from "../../shared/constants";

const PasswordChangeSuccessModal = (props) => {
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch({
            type: ACTION_CLOSE_PASSWORD_CHANGE_SUCCESS_MODAL
        });
    };

    return (
        <Dialog
            fullWidth
            maxWidth={"sm"}
            open={true}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogContent style={{ margin: "auto" }}>
                <Typography>Your password was changed successfully!</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>OK</Button>
            </DialogActions>
        </Dialog>);
};

export default PasswordChangeSuccessModal;
